// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_pe-0";